export default __webpack_public_path__ + "static/media/qr_code.6e30c3ef.jpg";